import React from "react";
import {
	InputAltitudeUnit,
	InputDistanceUnit,
	InputSpeedUnit,
	InputVolumeUnit,
} from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { Select, Space } from "antd";
import { currencies } from "../../../utils/Currencies/Currencies";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";

export default function UserPreferences({ addData }) {
	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("user preferences")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<InputSpeedUnit
						formstyle="form-input"
						id="attributes.speedUnit"
						name="attributes.speedUnit"
						onBlur={() => addData.setFieldTouched("attributes.speedUnit", true)}
						onChange={(value) =>
							addData.setFieldValue("attributes.speedUnit", value ? value : "")
						}
						value={addData.values.attributes.speedUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputDistanceUnit
						formstyle="form-input"
						id="attributes.distanceUnit"
						name="attributes.distanceUnit"
						onBlur={() =>
							addData.setFieldTouched("attributes.distanceUnit", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"attributes.distanceUnit",
								value ? value : "",
							)
						}
						value={addData.values.attributes.distanceUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputAltitudeUnit
						formstyle="form-input"
						id="attributes.altitudeUnit"
						name="attributes.altitudeUnit"
						onBlur={() =>
							addData.setFieldTouched("attributes.altitudeUnit", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"attributes.altitudeUnit",
								value ? value : "",
							)
						}
						value={addData.values.attributes.altitudeUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputVolumeUnit
						formstyle="form-input"
						id="attributes.volumeUnit"
						name="attributes.volumeUnit"
						onBlur={() =>
							addData.setFieldTouched("attributes.volumeUnit", true)
						}
						onChange={(value) =>
							addData.setFieldValue("attributes.volumeUnit", value ? value : "")
						}
						value={addData.values.attributes.volumeUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="currency"
						options={currencies}
						onBlur={() => addData.setFieldTouched("attributes.currency", true)}
						onChange={(value) =>
							addData.setFieldValue("attributes.currency", value ? value : "")
						}
						allowClear={false}
						value={addData.values.attributes.currency || ""}
					/>
				</div>
			</div>
		</div>
	);
}
